var _excluded = ["position", "color", "size"];

var _templateObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import * as React from 'react';
import { Box } from "../box";
import { keyframes } from '@emotion/core';
var LoadingSpinnerAnimation = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%{\n    transform:rotateZ(0deg);\n  }\n  100%{\n    transform:rotateZ(360deg);\n  }\n"])));
var sizes = {
  small: '12px',
  medium: '18px',
  large: '40px'
};

var getLoaderStyles = function getLoaderStyles(props) {
  return {
    position: props.position,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:after': {
      width: sizes[props.size] || sizes.medium,
      height: sizes[props.size] || sizes.medium,
      content: "''",
      border: '2px solid transparent',
      borderTopColor: props.color,
      borderLeftColor: props.color,
      borderRightColor: props.color,
      borderRadius: '100%',
      animation: "".concat(LoadingSpinnerAnimation, " 750ms linear infinite")
    }
  };
};

var Loader = function Loader(props) {
  var _props$position = props.position,
      position = _props$position === void 0 ? 'relative' : _props$position,
      _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      others = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({}, others, {
    position: position,
    color: color,
    size: size,
    _getBaseStyle: getLoaderStyles
  }));
};

Loader.displayName = 'Loader';
export { Loader };
export default Loader;